<template>
  <el-form
    :model="accessApacheForm"
    :rules="accessApacheRules"
    ref="accessApacheForm"
    label-width="160px"
    :inline-message="true"
    class="access-apache-form rule-form"
  >
    <div class="access-apache-form-pattern">
      <el-form-item prop="logFormat" label="日志格式：">
        <el-select
          style="width: 100%;"
          v-model="accessApacheForm.logFormat"
          placeholder="请选择日志格式"
          @change="onSelectFormat"
          :disabled="formType === 'SHOW'"
        >
          <el-option
            v-for="(format, index) in formatOptions"
            :key="index"
            :label="format"
            :value="format"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="pattern" label="APACHE 日志配置：">
        <el-input
          :title="accessApacheForm.pattern"
          v-model="accessApacheForm.pattern"
          type="textarea"
          :autosize="{ minRows: 4 }"
          disabled
        >
        </el-input>
        <el-button
          v-if="formType !== 'SHOW'"
          class="pattern-btn"
          type="primary"
          @click="onParseApache"
          >测试</el-button
        >
      </el-form-item>
      <el-form-item
        v-for="(result, index) in accessApacheForm.results"
        :prop="`results[${index}].key`"
        :key="index"
        :rules="accessApacheRules.results"
      >
        <span slot="label" v-if="index === 0"> 提取结果：</span>
        <el-col v-if="result" :span="12" style="padding-left: 0;">
          <el-input :title="result.key" v-model="result.key" disabled></el-input>
        </el-col>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import Validator from '../../../../utils/Validator';

export default {
  name: 'AccessApacheRuleCreator',

  props: {
    accessConfigForm: {
      type: Object
    },
    formType: {
      type: String
    }
  },

  data() {
    const validatorRequired = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.required()).validate();
    };

    const validatorStandardStr = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isStandardStr())
        .validate();
    };

    const validatorLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(50)).validate();
    };

    return {
      errorTip: '',
      formatOptions: ['common', 'combined'],
      accessApacheForm: {
        pattern: '',
        logFormat: '',
        results: [
          {
            key: '',
            value: ''
          }
        ]
      },
      accessApacheRules: {
        pattern: [
          { required: true, message: '请输入 APACHE 日志配置', trigger: 'change' },
          { validator: validatorRequired, message: '请输入 APACHE 日志配置', trigger: 'change' }
        ],
        logFormat: [
          { required: true, message: '请选择日志格式', trigger: 'change' },
          { validator: validatorRequired, message: '请选择日志格式', trigger: 'change' }
        ],
        results: [
          {
            required: true,
            message: 'key 不能为空',
            trigger: 'blur'
          },
          { validator: validatorRequired, message: 'key 不能为空', trigger: ['blur', 'change'] },
          { validator: validatorStandardStr, trigger: 'blur' },
          { validator: validatorLength, trigger: 'blur' }
        ]
      },
      apacheConfig: {
        common: 'LogFormat "%h %l %u %t "%r" %>s %b" common',
        combined: 'LogFormat "%h %l %u %t "%r" %>s %b "%{Referer}i" "%{User-Agent}i"" combined'
      },
      apacheConfigRule: {
        '%h': ['remote_addr'],
        '%l': ['remote_ident'],
        '%u': ['remote_user'],
        '%t': ['time_local'],
        '%r': ['request_method', 'request_uri', 'request_protocol'],
        '%>s': ['status'],
        '%b': ['response_size_bytes'],
        '%{Referer}i': ['http_referer'],
        '%{User-Agent}i': ['http_user_agent']
      }
    };
  },

  created() {
    this.getData();
  },

  methods: {
    /**
     * 本地存储数据，用来步骤切换时回显数据
     */
    getData() {
      this.accessApacheForm = {
        pattern: this.accessConfigForm.pattern,
        logFormat: this.accessConfigForm.logFormat,
        results: this.accessConfigForm.results
      };
    },
    /**
     * 选择日志格式显示不同的配置
     */
    onSelectFormat(val) {
      this.accessApacheForm.pattern = this.apacheConfig[val];
      this.accessApacheForm.results = [
        {
          key: ''
        }
      ];
    },
    /**
     * Apache 解析
     */
    onParseApache() {
      if (!this.accessApacheForm.pattern) {
        return;
      }

      let tempResults = [];
      Object.keys(this.apacheConfigRule).forEach(item => {
        if (this.accessApacheForm.pattern.indexOf(item) > -1) {
          tempResults = tempResults.concat(this.apacheConfigRule[item]);
        }
      });

      this.accessApacheForm.results = tempResults.map(item => ({
        key: item
      }));
    },
    onSaveData() {
      return this.accessApacheForm;
    },
    /**
     * 提交验证
     */
    onValidate() {
      return this.$refs.accessApacheForm.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.access-apache-form {
  &-pattern {
    position: relative;

    .pattern-btn {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(110%);
    }
  }
}
</style>
